import './app.css';
import './styles/global.css';
import './styles/dashboard.css';
import './styles/glass.css';
import './styles/theme.css';
import './lib/theme.svelte';
import { mount } from 'svelte';
import App from './App.svelte';

const app = mount(App, { target: document.getElementById('app')! });
export default app;
